import type { ReactElement } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/shared/components/ui/Tooltip';
import { PersonAvatar } from './PeopleTeamAvatars';

interface PersonAvatarTooltipProps {
  name: string;
  initials: string;
  imageUrl?: string;
  role?: string;
  children: ReactElement;
}

export function PersonAvatarTooltip({
  name,
  initials,
  imageUrl,
  role,
  children,
}: PersonAvatarTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="top" className="px-2.5 py-2">
        <div className="flex items-center gap-2">
          <PersonAvatar initials={initials} imageUrl={imageUrl} />
          <div className="flex flex-col">
            <span className="text-xs font-medium">{name}</span>
            {role && (
              <span className="text-[11px] text-popover-foreground/60">
                {role}
              </span>
            )}
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
